// Register script
import './register-page';